import { environment } from '../../../environments/environment';

export interface FitionFirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
}

export function resolveFirebaseConfig(): FitionFirebaseConfig {
  return environment.firebase;
}
